module.exports = __webpack_public_path__ + "static/media/ferskvann.743d04ac.svg";